<form novalidate>
  <nsc-system-message></nsc-system-message>

  <nsc-card *ngIf="content.welcomeMessage">
    <nsc-card-title>School Notifications</nsc-card-title>
    <nsc-card-content>
      <div class=" nsc-welcome-message" [innerHTML]="content.welcomeMessage | safeHtml:'html'"></div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="md" *ngIf="content.welcomeMessage"></nsc-spacer>

  <nsc-card>
    <nsc-card-title>Clearinghouse Notifications</nsc-card-title>
    <nsc-card-content>
      <div >
        <p>
          Payment will be accepted, if a cost is involved, with any major credit or debit card. Your credit or debit card is not charged until your school sends your transcript(s). However, if you use a debit card, your bank may put a hold on your funds when we pre-authorize your payment. If you have questions on the pre-authorization, please contact your bank.
        </p>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="md"></nsc-spacer>

  <div class="nsc-form-actions">
    <button
      mat-raised-button
      id="ordertranscript_button"
      class="nsc-form-actions__button button-big"
      color="primary"
      type="button"
      (click)="continue()"> Order Transcript(s) <mat-icon aria-hidden="true">chevron_right</mat-icon></button>
  </div>
  <nsc-spacer size="md"></nsc-spacer>
  <div >
    <p align="center">
      <a id="view_transcript_status" aria-label="View Transcript Order Status" [routerLink]="[]" (click)="openConfirmationDialog()">View Transcript Order Status</a>
    </p>
  </div>
</form>
